export default {
  align: 'center',
  emptyBtn: false,
  submitBtn: false,
  submitText: '保存',
  column: [
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      span: 12,
      search: true,
      cell: true,
      clearable: false,
      disabled: true,
      props: {
        label: 'title',
        value: 'key',
      },
      rules: [
        {
          message: '请选择车场名称',
          required: true,
        },
      ],
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',

    },
    {
      label: '车牌号',
      prop: 'carNo',
      type: 'input',
      span: 12,
      disabled: true,
    },
    {
      label: '客户姓名',
      prop: 'customerName',
      type: 'input',
      maxlength:10,
      span: 12,
      disabled: true,
      rules:[
        {
          required: true,
          message: '请输入客户姓名',
          trigger: 'blur',
        }],
    },
    {
      label: '客户手机',
      prop: 'customerPhone',
      type: 'input',
      maxlength:11,
      span: 12,
      disabled: true,
      rules:[
        {
          required: true,
          message: '请输入手机号',
          trigger: 'blur',
        },
        { min: 11, max: 11, message: '长度为11个字符', trigger: 'blur' },
        { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '手机号格式错误' }
      ],
    },
    {
      label: '收费套餐',
      prop: 'ruleId',
      type: 'tree',
      dicData: [],
      disabled: true,
      props: {
        label: 'setmealName',
        value: 'id',
      },
      rules: [
        {
          required: true,
          message: '请选择收费标准',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '收费套餐',
      span: 12,
      hide: true,
      disabled:true,
      type: 'input',
      display:false,
      prop: 'ruleName',
      rules: [
        {
          required: true,
          message: '请选择收费套餐',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '开始日期',
      prop: 'startTime',
      type: 'date',
      span: 12,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd',
      rules: [
        {
          required: true,
          message: '请选择开始日期',
          trigger: 'blur',
        },
      ],
      clearable:false,
      disabled: false,
    },
    {
      label: '租赁时长',
      prop: 'cycleNum',
      disabled: false,
      type: 'tree',
      dicData: [],
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      rules: [
        {
          required: true,
          message: '请选择租赁时长',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '结束日期',
      prop: 'buyEndTime',
      type: 'date',
      span: 12,
      disabled: true,
    },
    {
      label: '优惠规则',
      prop: 'discountId',
      type: 'tree',
      dicData: [],
      formslot:true,
      disabled: true,
      props: {
        label: 'discountName',
        value: 'id',
      },
      rules: [
        {
          required: false,
          message: '请选择优惠规则',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '优惠规则',
      span: 12,
      hide: true,
      disabled:true,
      type: 'input',
      display:false,
      prop: 'discountName',
    },
    {
      label: '应缴金额',
      prop: 'shouldMoney',
      type: 'input',
      span: 12,
      disabled: true,
    },
    {
      label: '优惠金额',
      prop: 'cutMoney',
      type: 'input',
      span: 12,
      disabled: true,
    },
    {
      label: '实缴金额',
      prop: 'payMoney',
      type: 'input',
      span: 12,
      disabled: true,
    },
    {
      label: '小区名称',
      prop: 'communityName',
      type: 'input',
      span: 12,
      display:false,
      disabled: true,
    },
    {
      label: '房产信息',
      prop: 'areaName',
      type: 'input',
      span: 12,
      disabled: true,
      readonly:true,
    },

    {
      label: '收款方式',
      prop: 'payType',
      type: 'input',
      span: 12,
      disabled: false,
      formslot: true,
      rules: [
        {
          required: true,
          message: '请选择收款方式',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收款类型',
      prop: 'payScene',
      type: 'input',
      span: 12,
      display: true,
      disabled: false,
      formslot: true,
      rules: [
        {
          required: true,
          message: '请选择收款类型',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收款码',
      prop: 'authCode',
      type: 'input',
      span: 12,
      display: true,
      disabled: false,
      formslot: true,
    },
    {
      label: '车辆类别',
      span: 8,
      hide: true,
      disabled:true,
      type: 'input',
      display:false,
      prop: 'carCategory',
    },
    {
      label: '车辆类型',
      span: 8,
      hide: true,
      disabled:true,
      type: 'input',
      display:false,
      prop: 'carType',
    },

  ],
};

